import tw from 'tailwind-styled-components'
import {cn} from '@containers/html-utils'
import {Color, Size, State} from '../link-button-new/types'

const primaryMixin = (forcedState?: State, disabled?: boolean): string => {
  if (disabled) {
    return 'text-action-disabled'
  }

  const cx: string[] = ['cursor-pointer']
  if (forcedState === 'active') {
    cx.push('text-action-pressed')
  } else if (forcedState === 'hover') {
    cx.push('text-action-hover')
  } else if (forcedState === 'default') {
    cx.push('text-action-default')
  } else {
    cx.push(
      'text-action-default',
      'hover:text-action-hover',
      'active:text-action-pressed'
    )
  }
  return cx.join(' ')
}

const secondaryMixin = (forcedState?: State, disabled?: boolean): string => {
  if (disabled) {
    return 'text-action-disabled'
  }

  const cx: string[] = ['cursor-pointer']
  if (forcedState === 'active') {
    cx.push('text-placeholder-new')
  } else if (forcedState === 'hover') {
    cx.push('text-primary')
  } else if (forcedState === 'default') {
    cx.push('text-secondary')
  } else {
    cx.push(
      'text-secondary',
      'hover:text-primary',
      'active:text-placeholder-new'
    )
  }
  return cx.join(' ')
}

const colorMixin = (p: {
  $color: Color
  $forcedState?: State
  $disabled?: boolean
}): string => {
  switch (p.$color) {
    case 'primary':
      return primaryMixin(p.$forcedState, p.$disabled)
    case 'secondary':
      return secondaryMixin(p.$forcedState, p.$disabled)
  }
  return ''
}

const textMixin = (size: Size): string => {
  const cx: string[] = ['leading-4']
  switch (size) {
    case 'md':
      cx.push('text-14')
      break
    case 'sm':
      cx.push('text-12')
      break
  }
  return cx.join(' ')
}

export const TwLink = tw.a<{
  $color: Color
  $size: Size
  $disabled?: boolean
  $forcedState?: State
}>`
  select-none
  w-fit
  text-sm-regular
  flex
  gap-4
  items-center
  justify-center
  ${p => cn(colorMixin(p), textMixin(p.$size))}
`

export const TwText = tw.span`
  whitespace-nowrap
  overflow-hidden
  text-ellipsis
`
